import { createTheme, alpha } from '@mui/material/styles';
import type { PaletteMode } from '@mui/material';

const sharedShape = { borderRadius: 10 };

const sharedTypography = {
  fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", "Arial", sans-serif',
  h6: { fontWeight: 600, letterSpacing: '-0.01em' },
};

const sharedComponents = {
  MuiAppBar: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none' as const,
      },
    },
  },
};

export function createAppTheme(mode: PaletteMode) {
  const isDark = mode === 'dark';
  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? '#6fa8e8' : '#4a90e2',
        dark: isDark ? '#4a90e2' : '#2d6bb8',
        light: isDark ? '#9ec5f0' : '#7ab0eb',
      },
      secondary: {
        main: isDark ? '#54d98c' : '#2ecc71',
      },
      background: isDark
        ? {
            /** Darkest layer: main workspace behind tabs + split panes */
            default: '#080b10',
            /** Elevated panels (content rail, dialogs, cards) — visibly above `default` */
            paper: '#121b28',
          }
        : {
            default: '#eef1f6',
            paper: '#ffffff',
          },
      divider: isDark ? 'rgba(255, 255, 255, 0.12)' : alpha('#0f172a', 0.09),
    },
    shape: sharedShape,
    typography: sharedTypography,
    components: sharedComponents,
  });
}
